import { Permission } from '@cims-online/shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { useRestoreDesignSubmittalMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRestoreNotification } from 'hooks/notificationHandler'
import { DesignSubmittal } from '../../../../DesignSubmittalLogContext/types'

export function useRestoreOptions(): RestoreRowActionOptions<DesignSubmittal> {
  const { refetch } = useDesignSubmittalLogContext()
  const [restore] = useRestoreDesignSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      restoreDesignSubmittal: {
        designSubmittal: { sharePointFolderName },
      },
    }) => simpleRestoreNotification(sharePointFolderName),
  })
  return {
    permission: Permission.RemoveRestoreDesignSubmittal,
    onRestore: async ({ id }) => {
      await restore({ variables: { id } })
      await refetch()
    },
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
    default: 'active',
  }
}
